module.exports = __webpack_public_path__ + "media/images/front/common/icon_clipboard_list-5ff6b15f3a448a19566207a65ec031a4.png";